'use strict';

angular.module('PinMeTo.services').service('pmtAlertService', [
	'$i18next',
	function ($i18next) {
		this.alertBox = {
			active: false,
			confirmTitle: 'Ok',
			cancelTitle: 'Cancel'
		};

		this.alert = function (caller) {
			this.alertBox.active = true;
			this.alertBox.busy = false;
			this.alertBox.title = caller.title;
			this.alertBox.body = caller.body;
			this.alertBox.confirm = caller.confirm;
			this.alertBox.cancel = caller.cancel;
			this.alertBox.confirmTitle = caller.confirmTitle || 'Ok';
			this.alertBox.cancelTitle = caller.cancelTitle || 'Cancel';
			this.alertBox.action2 = caller.action2;
			this.alertBox.action2Title = caller.action2Title || 'Action2';
		};

		this.close = function () {
			this.alertBox.active = false;
			this.alertBox.confirmTitle = 'Ok';
			this.alertBox.cancelTitle = 'Cancel';
			delete this.alertBox.title;
			delete this.alertBox.body;
			delete this.alertBox.confirm;
			delete this.alertBox.cancel;
			delete this.alertBox.busy;
			delete this.alertBox.action2;
		};

		this.errorAlert = (error, title = 'Error') => {
			const errorLookup = {
				400: $i18next.t('posts.post_service.error400'),
				401: $i18next.t('posts.post_service.error401'),
				403: $i18next.t('posts.post_service.error403'),
				500: $i18next.t('posts.post_service.error500'),
				502: $i18next.t('posts.post_service.error502504'),
				504: $i18next.t('posts.post_service.error502504')
			};

			const getErrorMessage = function (errorObject) {
				if (typeof errorObject === 'string') {
					if (errorObject.includes('TypeError')) {
						return $i18next.t('general.unknown_error');
					}
					return errorObject;
				}
				if (errorObject.errorId && errorObject.error?.message) {
					return `${errorObject.error.message} Please contact support and provide this id: ${errorObject.errorId}`;
				}
				if (errorObject.message) {
					return errorObject.message;
				}

				return errorLookup[errorObject.status] || $i18next.t('general.unknown_error');
			};

			const errorMessage = getErrorMessage(error?.data || error || {});

			return new Promise(resolve => {
				this.alert({
					title: title,
					body: errorMessage,
					confirm: () => {
						resolve(error);
						this.close();
					}
				});
			});
		};

		this.asyncAlert = (title, message, confirmTitle, cancelTitle) =>
			new Promise((resolve, reject) =>
				this.alert({
					title,
					body: message,
					confirmTitle: confirmTitle || 'Ok',
					cancelTitle: cancelTitle || 'Cancel',
					confirm: () => {
						resolve(null);
						this.close();
					},
					cancel: () => {
						reject(null);
						this.close();
					}
				})
			);
	}
]);
